import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/header-candidate.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { backendApi } from "../../api/apiService.js";
import { ToastContainer, toast } from "react-toastify";
import $ from "jquery";
import noData from "../../images/noData.png";
import { format, addDays } from "date-fns";
import Select from "react-select";
import { useSelector } from "../../components/hooks/hooks.js";
import Loading from "../../images/loading.gif";
import { useLocation } from "react-router-dom";

export default function CloneRequirement() {
    const { userDetails, userData, userId, siteId } = useSelector(
        (state) => state.login
    );
    const locationData = useLocation();
    const { props } = locationData.state || {};
    console.log("Received Value:", props);
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [jobTypes, setJobTypes] = useState([]);
    const [statusTypes, setStatusTypes] = useState([]);
    const [priorityTypes, setPriorityTypes] = useState([]);
    const [status, setStatus] = useState("Open");
    const [priority, setPriority] = useState("High");
    const [jobType, setJobType] = useState("Full Time");
    const [summary, setSummary] = useState("");
    const [description, setDescription] = useState("");
    const [positionsOpen, setPositionsOpen] = useState("");
    // const [experience, setExperience] = useState("");
    const [Fromexperience, setFromExperience] = useState("");
    const [Toexperience, setToExperience] = useState("");
    const [NoticePeriod, setNoticePeriod] = useState("");
    const [WorkMode, setWorkMode] = useState("");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState();
    const [salary, setSalary] = useState("");
    const [location, setLocation] = useState("");
    const [probability, setprobability] = useState("");
    const [openings, setOpenings] = useState([]);
    const [recruitersList, setRecruitersList] = useState([]);
    const [recruiters, setRecruiters] = useState([]);
    const [userList, setUserList] = useState([]);
    const [users, setUsers] = useState([]);
    const [jobSkills, setJobSkills] = useState([
        { label: "Type to search skills", value: "default" },
    ]);
    const [comments, setComments] = useState("");
    const [projectName, setProjectName] = useState("");
    const [jobTab, setJobTab] = useState(true);
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [skillId, setSkillId] = useState([]);
    const [menuClick, setMenuClick] = useState(false);
    const toggleMenu = () => {
        setMenuClick(!menuClick);
    };
    const closeMenu = () => {
        setMenuClick(false);
    };
    useEffect(() => {
        openingInit();
        // openingHistory();
        getUserList();
    }, []);

    // const workExperienceOptions = [
    //   { value: "0-1", label: "0-1 Years" },
    //   { value: "1-2", label: "1-2 Years" },
    //   { value: "2-3", label: "2-3 Years" },
    //   { value: "3-4", label: "3-4 Years" },
    //   { value: "4-5", label: "4-5 Years" },
    //   { value: "5-6", label: "5-6 Years" },
    //   { value: "6-7", label: "6-7 Years" },
    //   { value: "7-8", label: "7-8 Years" },
    //   { value: "8-9", label: "8-9 Years" },
    //   { value: "9-10", label: "9-10 Years" },
    //   { value: "10+", label: "10+ Years" },
    // ];

    const handleStartDateChange = (date) => {
        setStartDate(date);

        // Automatically set the closing date with an interval of 10 days
        const newEndDate = date ? addDays(date, 10) : null;
        setEndDate(newEndDate);
    };
    const [DesignationData, setDesignationData] = useState([]);
    const [DepartmentData, setDepartmentData] = useState([]);
    useEffect(() => {
        getAll();
        getAllDepartments();
    }, []);
    const getUserList = () => {
        const api = {
            functionName: "userListing",
            site_id: userDetails[0].site_id,
        };
        backendApi(api).then((response) => {
            if (response.success === "1") {
                const recruiters = response.dataSet
                    .filter((obj) => obj.roleId === 1 || obj.roleId === 5)
                    .map((m) => ({
                        ...m,
                        label: `${m.first_name} ${m.last_name}`,
                        value: m.id,
                    }));
                setRecruitersList(recruiters);
                setUserList(
                    response.dataSet.map((m) => ({
                        ...m,
                        label: `${m.first_name} ${m.last_name}`,
                        value: m.id,
                    }))
                );

                if (response.dataSet.length > 0 && props?.managers) {
                    const selectedManagers = props.managers.map((manager) => {
                        const matchedUser = response.dataSet.find((user) => user.id === manager.reportingManagers_id);
                        console.log(matchedUser, "matchedManagers");

                        return matchedUser ? { value: matchedUser.id, label: `${matchedUser.first_name} ${matchedUser.last_name}` } : null;
                    }).filter(Boolean);

                    setUsers(selectedManagers);
                }

                if (response.dataSet.length > 0 && props?.recruiters) {
                    const selectedrecruiters = props.recruiters.map((recruiters) => {
                        const matchedUser = response.dataSet.find((user) => user.id === recruiters.recruiter_id);
                        console.log(matchedUser, "matchedManagers");

                        return matchedUser ? { value: matchedUser.id, label: `${matchedUser.first_name} ${matchedUser.last_name}` } : null;
                    }).filter(Boolean);

                    setRecruiters(selectedrecruiters);
                }

                // getRequirementOpenings();
            }
        });
    };
    const getAll = () => {
        var req = {
            functionName: "designationAllList",
            site_id: localStorage.getItem("siteId"),
            is_active: "1",
        };
        backendApi(req).then((response) => {
            console.log("Status Results", response);
            if (response.success == 1) {
                console.log("req", response);
                setDesignationData(response.dataSet);
            } else {
                console.log("Error in status viewing.");
                return false;
            }
        });
    };
    const getAllDepartments = () => {
        var req = {
            functionName: "departmentProjectListing",
            site_id: localStorage.getItem("siteId"),
            is_active: "1",
        };
        backendApi(req).then((response) => {
            console.log("Status Results", response);
            if (response.success == 1) {
                console.log("req", response);
                setDepartmentData(response.dataSet);
            } else {
                console.log("Error in status viewing.");
                return false;
            }
        });
    };

    // const handleSkillInput = (e) => {
    //   if (e.length >= 3) {
    //     const api = {
    //       functionName: "searchingSkills",
    //       site_id: userDetails[0].site_id,
    //       searchParams: e,
    //     };
    //     backendApi(api).then((response) => {
    //       console.log("🚀 ~ backendApi ~ response:", response);
    //       const transformedOptions = response.resumes.map((skill, index) => ({
    //         value: index + 1,
    //         label: skill.skill_name,
    //       }));
    //       setJobSkills(transformedOptions);
    //     });
    //   }
    // };

    const handleSkillInput = (e) => {
        if (e.length >= 3) {
            const api = {
                functionName: "skillSetListing",
                siteId: userDetails[0].site_id,
                searchParam: e,
            };
            backendApi(api).then((response) => {
                console.log("🚀 ~ backendApi ~ response:", response);
                const transformedOptions = response.dataSet.map((skill, index) => ({
                    value: skill.id,
                    label: skill.skill_name,
                }));
                console.log(
                    "🚀 ~ transformedOptions ~ transformedOptions:",
                    transformedOptions
                );
                setJobSkills(transformedOptions);
            });
        }
    };
    const handleSkillChange = (selectedOption) => {
        if (selectedOption.some((o) => o.value === "default")) return false;
        setSkillId(selectedOption);
        setSelectedSkills(selectedOption);

        console.log("sskilss", selectedSkills);
    };

    useEffect(() => {
        console.log("🚀 ~ CreateJobOpening ~ selectedSkills:", selectedSkills);
    }, [selectedSkills]);
    const insertNewSkill = (event) => {
        if (event.key == "Enter") {
            // event.preventDefault();
            var req = {
                functionName: "addUpdateSkill",
                siteId: userDetails[0].site_id,
                skillName: event.target.value,
            };

            backendApi(req).then((response) => {
                if (response.success === "1") {
                    // Update jobSkills state with the new skill
                    const newSkills = [
                        ...jobSkills,
                        { label: event.target.value, value: response.dataSet },
                    ];
                    setJobSkills(newSkills);

                    // Assuming your Select component uses a value prop for selection
                    const newSelectedValue = {
                        label: event.target.value,
                        value: response.dataSet,
                    };

                    // Check if the Select component supports programmatic selection
                    if (typeof Select.setValue === "function") {
                        // Use setValue method for direct selection (if available)
                        Select.setValue(newSelectedValue);
                    } else {
                        // Fallback: Update selectedSkills state to trigger selection update
                        setSelectedSkills([newSelectedValue]);
                    }
                }
            });
        }
    };

    const openingInit = () => {
        var req = {
            functionName: "job_opening_init",
            site_id: userDetails[0].site_id,
        };
        console.log("req", req);
        backendApi(req).then((response) => {
            console.log("resp", response);
            if (response.success === "1") {
                console.log(response, "logresponse");

                setJobTypes(response.job_type);
                setStatusTypes(response.status);
                setPriorityTypes(response.priority);
                // const transformedOptions = response.skills.map((skill, index) => ({
                //   value: index + 1,
                //   label: skill.skill_name,
                // }));
                // setJobSkills(transformedOptions);
            } else {
                toast.warn("Wrong username or password", { containerId: "D" });
                return false;
            }
        });
    };

    // ======================================================
    useEffect(() => {
        if (props) {
            setSummary(props.summary || "");
            setDescription(props.description || "");
            setPositionsOpen(props.no_of_position || "");
            setStartDate(props.start_date ? new Date(props.start_date) : null);
            setEndDate(props.end_date ? new Date(props.end_date) : null); setStatus(props.status || "");
            setPriority(props.priority || "");
            if (props?.experiance) {
                const experienceParts = props.experiance.split("-");
                setFromExperience(experienceParts[0] || "");
                setToExperience(experienceParts[1] || "");
            }
            if (props?.skills) {
                const selectedSkills = props.skills.map(skill => ({
                    value: skill.id,
                    label: skill.skill_name
                }));
                setSkillId(selectedSkills);
                setSelectedSkills(selectedSkills);
            }
            setNoticePeriod(props.notice_period || "");
            setWorkMode(props.job_mode || "");
            setJobType(props.job_type || "");
            setLocation(props.location || "");
            setprobability(props.closingProbability || "");
            setSalary(props.salary || "");
            setComments(props.comments || "");
            setProjectName(props.project_name || "");
        }
    }, [props]);

    const createOpening = (e) => {
        e.preventDefault();
        if (isSubmitting) {
            return;
        }

        if (summary === "") {
            toast.warn("Please enter posting summary", { containerId: "D" });
            return false;
        } else if (description === "") {
            toast.warn("Please enter posting description", { containerId: "D" });
            return false;
        } else if (!endDate) {
            toast.warn("Please enter closing date", { containerId: "D" });
            return false;
        } else if (positionsOpen === "") {
            toast.warn("Please enter number of open positions", { containerId: "D" });
            return false;
        } else if (status === "") {
            toast.warn("Please select a status", { containerId: "D" });
            return false;
        } else if (priority === "") {
            toast.warn("Please select a priority", { containerId: "D" });
            return false;
        } else if (Fromexperience === "") {
            toast.warn("Please select From Year of Experience", { containerId: "D" });
            return false;
        } else if (Toexperience === "") {
            toast.warn("Please select From Year of Experience", { containerId: "D" });
            return false;
        } else if (jobType === "") {
            toast.warn("Please select job type", { containerId: "D" });
            return false;
        } else if (location === "") {
            toast.warn("Please enter posting location", { containerId: "D" });
            return false;
        } else if (startDate >= endDate) {
            toast.warn("Open Date must be earlier than Target Date.", {
                containerId: "D",
            });
            return false;
        } else if (selectedSkills.length == 0) {
            toast.warn("Please select required skill set", {
                containerId: "D",
            });
            return false;
        }

        let formattedStartDate;
        let formattedEndDate;
        if (endDate) {
            formattedStartDate = startDate.toISOString().split("T")[0];
            formattedEndDate = endDate.toISOString().split("T")[0];
        }
        const experience = `${Fromexperience}-${Toexperience}`;
        const skillLabels = selectedSkills
            .filter((skill) => skill && skill.label)
            .map((skill) => skill.label);

        setIsSubmitting(true);

        var req = {
            functionName: "job_opening_save",
            summary: summary.replace(/['"]/g, "\\$&"),
            description: description.replace(/['"]/g, "\\$&"),
            no_of_position: positionsOpen,
            start_date: formattedStartDate,
            end_date: formattedEndDate,
            status: status,
            priority: priority,
            experiance: experience,
            notice_period: NoticePeriod,
            job_mode: WorkMode,
            job_type: jobType,
            location: location,
            closingProbability: probability,
            salary: salary,
            skill: skillLabels,
            created_by: localStorage.getItem("userId"),
            site_id: localStorage.getItem("siteId"),
            recruiters: recruiters.map((data) => data.value),
            reportingManagers: users.map((data) => data.value),
            comments: comments.replace(/['"]/g, "\\$&"),
            project_name: projectName.replace(/['"]/g, "\\$&"),
        };
        console.log("req", req);
        backendApi(req).then((response) => {
            console.log("resp", response);
            if (response.success === "1") {
                setIsSubmitting(false);
                toast.success("Job Opening created succesfully.", { containerId: "D" });
                // openingHistory();
                console.log("insertId", response.skill.insertId);
                // resetForm();
                setTimeout(() => {
                    navigate(`/process`, {
                        state: {
                            props: response.skill.insertId,
                        },
                    });
                }, 2000);
            } else {
                setIsSubmitting(false);
                toast.warn("Error creating job opening", { containerId: "D" });
                return false;
            }
        });
    };

    const handlePositionsChange = (e) => {
        const inputValue = e.target.value;

        // Use a regular expression to allow only positive integers
        if (/^[1-9]\d*$/.test(inputValue) || inputValue === "") {
            setPositionsOpen(inputValue);
        }
    };

    const viewHistory = () => {
        const yourProp = openings;
        navigate(`/jobHistory`, {
            state: {
                props: yourProp,
            },
        });
    };

    const goBack = () => {
        navigate(-1);
    };

    // const customStyles = {
    //   option: (provided, state) => ({
    //     ...provided,
    //     fontSize: "13px", // Adjust font size if needed
    //     backgroundColor: state.isFocused ? "#e0f0ff" : provided.backgroundColor, // Blue background on hover
    //     color: "#333", // Text color
    //     cursor: "pointer",
    //     margin: "6px",
    //     padding:"20px"
    //   }),
    //   menu: (provided) => ({
    //     ...provided,
    //     zIndex: 9999, // Ensure the menu is on top
    //   }),
    // };
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            fontSize: "13px",
            backgroundColor: state.isFocused ? "#007BFF" : "#fff",
            color: state.isFocused ? "red" : "blue",
            cursor: "pointer",
            padding: "10px 15px",
            margin: "2px 0",
            borderRadius: "5px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            padding: "5px 0",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
            backgroundColor: "#fff",
        }),
        control: (provided) => ({
            ...provided,
            fontSize: "13px",
            padding: "5px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            border: "1px solid #ddd",
        }),
    };




    return (
        <div className="main-wrapper">
            <div className="top-color"></div>
            <ToastContainer
                enableMultiContainer
                containerId={"D"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
            <div className="content-wrapper">
                <Header
                    Header="New Requirement"
                    toggleMenu={toggleMenu}
                    menuClick={menuClick}
                />
                <div className="main-container">
                    <div className="card main-card">
                        <div className="card-body">
                            <>
                                {jobTab ? (
                                    <>
                                        {/* <div className="text-end mb-2">
              <button
                className="btn-btn btn btn-btn2"
                onClick={() => {
                  setJobTab(false);
                  viewHistory();
                }}
              >
                History
              </button>
            </div> */}
                                        <div className="row  mb-0 mb-md-3">
                                            <div class="form-group col-md-6 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Job Title : <span className="text-danger">*</span>{" "}
                                                </label>
                                                {/* <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Designation"
                  value={summary}
                  onChange={(e) => setSummary(e.target.value)}
                /> */}
                                                <select
                                                    className="form-control"
                                                    value={summary}
                                                    onChange={(e) => setSummary(e.target.value)}
                                                >
                                                    <option value="">Select a Job Title</option>
                                                    {DesignationData.map((priority) => (
                                                        <option key={priority.id} value={priority.designation_name}>
                                                            {priority.designation_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            {/* <div class="col-md-6">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <span class="mb-0">AI GENERATED CONTENT</span>
                  <button class="btn btn-btn1 bg-success btn-sm">Prepare JD</button>
                </div>
                <div class="crnRes cards-crnRes">
                  <div class="crmPost border-0">

                  </div>
                </div>
              </div> */}
                                        </div>
                                        <div class="form-group col-md-6 mb-md-0 mb-3">
                                            <label htmlFor="" className="form-label">
                                                Posting Description: <span className="text-danger">*</span>{" "}
                                            </label>
                                            <textarea
                                                className="form-control textarea"
                                                placeholder="Enter Posting Description"
                                                value={description}
                                                rows="3"
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                        </div>
                                        <br />
                                        <div className="row  mb-0 mb-md-3">
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Opening Date : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={handleStartDateChange}
                                                    className="form-control w-100"
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    minDate={new Date()}
                                                    showMonthDropdown
                                                    placeholderText="Select date "
                                                />
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    {" "}
                                                    Closing Date : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <DatePicker
                                                    selected={endDate}
                                                    minDate={new Date()}
                                                    onChange={(date) => setEndDate(date)}
                                                    className="form-control w-100"
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    placeholderText="Select date "
                                                />
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Job Opening Status : <span className="text-danger ">*</span>{" "}
                                                </label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => setStatus(e.target.value)}
                                                    value={status}
                                                >
                                                    <option value="">Select a Status</option>
                                                    {statusTypes.map((status) => (
                                                        <option key={status} value={status}>
                                                            {status}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Job Type : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => setJobType(e.target.value)}
                                                    value={jobType}
                                                >
                                                    <option value="">Select a Type</option>
                                                    {jobTypes.map((type) => (
                                                        <option key={type} value={type}>
                                                            {type}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row  mb-0 mb-md-3">
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Priority : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <select
                                                    className="form-control"
                                                    onChange={(e) => setPriority(e.target.value)}
                                                    value={priority}
                                                >
                                                    <option value="">Select a Priority</option>
                                                    {priorityTypes.map((priority) => (
                                                        <option key={priority} value={priority}>
                                                            {priority}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Salary per Annum :
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Salary"
                                                    value={salary}
                                                    onChange={(e) => setSalary(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group col-md-6 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Work Experience : <span className="text-danger">*</span>{" "}
                                                </label>
                                                {/* <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Work Experience in yrs"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                /> */}
                                                <div className="d-flex">
                                                    <select
                                                        className="form-control me-2"
                                                        name="fromYear"
                                                        value={Fromexperience}
                                                        onChange={(e) => setFromExperience(e.target.value)}
                                                    >
                                                        <option value="">From Year</option>
                                                        {[...Array(26).keys()].map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <select
                                                        className="form-control"
                                                        name="toYear"
                                                        value={Toexperience}
                                                        onChange={(e) => setToExperience(e.target.value)}
                                                    >
                                                        <option value="">To Year</option>
                                                        {[...Array(26).keys()].map((year) => (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row  mb-0 mb-md-3">
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Location : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Posting Location"
                                                    value={location}
                                                    onChange={(e) => setLocation(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Opening Closing Probability :{" "}
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="toYear"
                                                    value={probability}
                                                    onChange={(e) => setprobability(e.target.value)}
                                                >
                                                    <option value="">Select Probability</option>
                                                    {[...Array(10).keys()].map((index) => {
                                                        const percentage = (index + 1) * 10;
                                                        return (
                                                            <option key={percentage} value={percentage}>
                                                                {percentage} %
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>

                                            <div className="form-group col-md-6 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Skills : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <Select
                                                    isMulti
                                                    name="colors"
                                                    placeholder="Add Skills"
                                                    options={jobSkills}
                                                    value={skillId}
                                                    onChange={handleSkillChange}
                                                    onInputChange={(e) => handleSkillInput(e)}
                                                    onKeyDown={(event) => insertNewSkill(event)}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                // menuPlacement="top"
                                                // menuPosition="fixed"
                                                // menuIsOpen={true}
                                                />
                                            </div>
                                            <div className="form-group col-md-6 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Managers : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <Select
                                                    isMulti
                                                    name="colors"
                                                    placeholder="Add Skills"
                                                    options={userList}
                                                    value={users}
                                                    onChange={setUsers}
                                                    // onKeyDown={(event) => insertNewSkill(event)}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    styles={customStyles}

                                                // menuPosition="fixed"
                                                // menuIsOpen={true}
                                                />
                                            </div>
                                            <div className="form-group col-md-6 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Recruiters : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <Select
                                                    isMulti
                                                    name="colors"
                                                    placeholder="Add Skills"
                                                    options={recruitersList}
                                                    value={recruiters}
                                                    onChange={setRecruiters}
                                                    // onKeyDown={(event) => insertNewSkill(event)}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    styles={customStyles}

                                                // menuPosition="fixed"
                                                // menuIsOpen={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="row  mb-0 mb-md-3">
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Notice Period :{" "}
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="noticePeriod"
                                                    value={NoticePeriod}
                                                    onChange={(e) => setNoticePeriod(e.target.value)}
                                                >
                                                    <option value="">Select Notice Period</option>
                                                    <option value="Immediate">Immediate</option>
                                                    <option value="30">30 Days</option>
                                                    <option value="60">60 Days</option>
                                                    <option value="90">90 Days</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    No.of Positions : <span className="text-danger">*</span>{" "}
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter no: of positions"
                                                    value={positionsOpen}
                                                    onChange={handlePositionsChange}
                                                />
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Work Mode :{" "}
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="workMode"
                                                    value={WorkMode}
                                                    onChange={(e) => setWorkMode(e.target.value)}
                                                >
                                                    <option value="">Select Work Mode</option>
                                                    <option value="WFH">WFH</option>
                                                    <option value="WFO">WFO</option>
                                                    <option value="Hybrid">Hybrid</option>
                                                    <option value="Onsite">Onsite</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Project Or Department Name :{" "}
                                                </label>
                                                {/* <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Project Or Department Name"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                /> */}
                                                <select
                                                    className="form-control"
                                                    value={projectName}
                                                    onChange={(e) => setProjectName(e.target.value)}
                                                >
                                                    <option value="">Select Project Or Department Name</option>
                                                    {DepartmentData.map((priority) => (
                                                        <option
                                                            key={priority.id}
                                                            value={priority.departmentOrProject}
                                                        >
                                                            {priority.departmentOrProject}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row  mb-0 mb-md-3">
                                            <div className="form-group col-md-12 mb-md-0 mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Comments :{" "}
                                                </label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Comments (optional)"
                                                    value={comments}
                                                    rows={4}
                                                    onChange={(e) => setComments(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-12 d-flex flex-wrap align-items-center justify-content-end gap-3">
                                            <button
                                                type="button"
                                                className="btn btn-btn1 btn-btn"
                                                onClick={createOpening}
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <img
                                                        src={Loading}
                                                        alt="loaderImg"
                                                        width={20}
                                                        height={20}
                                                    ></img>
                                                ) : (
                                                    "Submit"
                                                )}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-btn2 btn-btn"
                                                onClick={goBack}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
}
